/**
 * Aplica máscara ao CEP no formato 99999-999
 * Aceita entrada parcial.
 */
export function aplicarMascaraCep(valor) {
    const apenasNumeros = valor.replace(/\D/g, '');
  
    if (apenasNumeros.length <= 5) {
      return apenasNumeros;
    }
  
    return `${apenasNumeros.slice(0, 5)}-${apenasNumeros.slice(5, 8)}`;
  }
  